import { render } from "./AdmCadEmpresaView.vue?vue&type=template&id=51eae2f4"
import script from "./AdmCadEmpresaView.vue?vue&type=script&lang=js"
export * from "./AdmCadEmpresaView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__